module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Light-a44d8c552d1c8cacede33b5c443d6780.woff2";